module.exports = __webpack_public_path__ + "static/media/salpro-nav.f945ebf6.png";